import { render } from "./Category.vue?vue&type=template&id=67aca38e&scoped=true"
import script from "@/wwwroot/js/category.js?vue&type=script&lang=js"
export * from "@/wwwroot/js/category.js?vue&type=script&lang=js"

import "@/wwwroot/css/category.css?vue&type=style&index=0&id=67aca38e&scoped=true&lang=css"
import "@/wwwroot/css/sharedStyles.css?vue&type=style&index=1&id=67aca38e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67aca38e"]])

export default __exports__